import { useCallback, useState } from "react";
import { Button, Form, Modal, ModalHeader, ModalFooter } from "reactstrap";

import { ActionType } from "Pages/Users/ManageUsers/ManageUsers";
import styles from "Pages/Admin/AdminConfiguration/AdminConfigModal/AdminConfigModal.module.css";
import useAlertContext from "Hooks/useAlertContext";

export interface IProps {
    activeModal: ActionType;
    getPageData: (ignore: boolean) => Promise<void>;
    onSetActiveModal: (modal: ActionType) => void;
    onSetSelectedRow: (row: any) => void;
    selectedRow: any;
}

export default function ResetPasswordModal({
    activeModal,
    onSetActiveModal,
    onSetSelectedRow,
    selectedRow,
}: IProps) {
    const [isReset, setIsReset] = useState(false);
    const { newAlert } = useAlertContext();

    async function resetPassword(e: React.FormEvent) {
        e.preventDefault();

        const body = {
            userId_or_email: selectedRow
                ? selectedRow.values.user_id ?? selectedRow.values.email
                : "",
        };
        const response = await fetch("/api/reset_password", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        const data = await response.json();
        console.log(data);
        if (response.ok) {
            setIsReset(true);
        } else {
            newAlert({
                color: "danger",
                message: data.detail,
            });
        }
    }

    const closeModal = useCallback(() => {
        onSetSelectedRow(undefined);
        onSetActiveModal("");
    }, [onSetActiveModal, onSetSelectedRow]);

    function signOut() {
        onSetActiveModal("");
    }

    return (
        <Modal isOpen={activeModal === "password"} toggle={closeModal} centered>
            <ModalHeader>Reset Password?</ModalHeader>
            {isReset ? (
                <div
                    className={styles.formSignin}
                    style={{ paddingLeft: "10px", paddingRight: "10px" }}
                >
                    <p>
                        Password has successfully been reset. A password
                        recovery email is being sent to:{" "}
                        {selectedRow?.original?.email ?? ""}{" "}
                    </p>
                </div>
            ) : (
                <div></div>
            )}
            <Form id="form" onSubmit={resetPassword}></Form>
            {!isReset ? (
                <ModalFooter id="modal_footer">
                    <Button
                        color="danger"
                        onClick={() => onSetActiveModal("")}
                        form="form"
                    >
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" form="form">
                        Continue
                    </Button>
                </ModalFooter>
            ) : (
                <ModalFooter id="modal_footer">
                    <Button
                        color="secondary"
                        onClick={() => signOut()}
                        form="form"
                    >
                        Close
                    </Button>
                </ModalFooter>
            )}
        </Modal>
    );
}
